<template>
  <div id="app" v-if="show">
    <keep-alive>
      <router-view v-if="$route.meta && $route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta || !$route.meta.keepAlive" />
  </div>
</template>
<script>
import { fetchGetTmpUuid, fetchPixelReport, fetchReportEvent } from '@/api'
import {
  getAppInfo,
  getPathLang,
  getStoredUserId,
  getStoredUserToken,
  getTtPixelId,
  setCookieAdId,
  setCookieFbc,
  setToufang
} from './utils/base'
import { getPaypalSdk } from './utils/paypal'
import { isFacebookWebView, getParam, isTiktokWebView } from './utils/tools'


export default {
  name: 'App',
  data() {
    return {
      show: false
      // Define any global data properties here
    }
  },
  methods: {
    getUuidCallback(){
      this.show = true
      this.reportBrowser()
      setTimeout(() => {
        fetchPixelReport({}, 'PageView')
        fetchReportEvent({ 
          type: 'show',
          position: 'pageView',
          ext: JSON.stringify({
            fbclid: getParam('fbclid') || '',
            isFb: +isFacebookWebView(),
          })
        })
      }, 100);
    },
    async getUuid(){
      try {
        if(getStoredUserId() && getStoredUserToken()){
          this.getUuidCallback();
          return
        }
        await fetchGetTmpUuid()
        this.getUuidCallback();
    }catch (error) {
      console.error('Error fetching UUID:', error)
      if (process.env.VUE_APP_ENV === 'dev') {
        this.show = true
      }
    }
    },
    reportBrowser(){  
      fetchReportEvent({
        type: 'browser',
        position: isFacebookWebView() ? '1' : '0',
        ext: JSON.stringify({
          ua: window.navigator.userAgent
        })
      }).catch(error => {
        console.error('Error reporting browser:', error)
      })
    },

  },
  mounted() {
    ttq.load(getTtPixelId())
    setToufang.apply(this);
    console.log('是否在fb中', isFacebookWebView())
    console.log('是否在tt中', isTiktokWebView())
    document.title = getAppInfo()?.name;
    setTimeout(() => {
      getPaypalSdk()
    }, 0);
    this.$i18n.locale = getPathLang()
    setCookieAdId();
    setCookieFbc();
    this.getUuid()

  }
}
</script>


<style lang="less">

</style>
